// ConfirmUser.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { client, API_BASE_PATH } from '../apiHelper';
import Input from '../components/ui/Input';


const ConfirmUser = () => {
    const { salt } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.clear()
    }, [])

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [passwordsMatchError, setPasswordsMatchError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage('');
        setError(false);
        setPasswordsMatchError(false);

        if (password !== confirmPassword) {
            setPasswordsMatchError(true);
            setMessage('Passwords do not match.');
            setError(true);
            return;
        }

        if (password.length < 8) {
            setMessage('Password must be at least 8 characters long.');
            setError(true);
            return;
        }

        setLoading(true);

        try {
            // console.log(`Attempting to confirm user with salt: ${salt} and set password.`);

            const response = await client.postData(`${API_BASE_PATH}/auth/confirm-invite`, { salt, password })
            setMessage('Password set successfully! Redirecting to login...');
            setError(false);
            setTimeout(() => {
                navigate('/');
            }, 2000);

        } catch (err) {
            console.error('Password setup error:', err);
            setMessage(`An unexpected error occurred: ${err?.response?.data?.detail || 'Please try again.'}`);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 font-sans p-4">
            <div className="bg-white px-8 py-16 rounded-2xl shadow-lg w-full max-w-md">
                {/* Logo added here */}
                <div className="flex justify-center mb-6">
                    <img
                        src="/logo.png"
                        alt="School Logo"
                        className="h-20"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://placehold.co/80x80/0000FF/FFFFFF?text=Logo'; // Reverted placeholder
                        }}
                    />
                </div>
                <h2 className="text-3xl font-semibold text-gray-800 mb-6 text-center">Set Your Password</h2>

                {message && (
                    <div className={`p-3 mb-4 rounded-lg text-sm ${error ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                            New Password
                        </label>
                        <Input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            className={`block w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${passwordsMatchError ? 'border-red-500' : 'border-gray-300'}`}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            error={message}
                            trailingIcon={
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="text-gray-500 hover:text-gray-700 focus:outline-none pointer-events-auto"
                                    aria-label={showPassword ? "Hide Password" : "Show Password"}
                                >
                                    {showPassword ? (
                                        // Eye slashed (hidden)
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                            <path d="M1 1l22 22" />
                                        </svg>
                                    ) : (
                                        // Eye open (visible)
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    )}
                                </button>
                            }
                        />
                        {/* <input
                            type="password"
                            id="password"
                            className={`block w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${passwordsMatchError ? 'border-red-500' : 'border-gray-300'}`}
                            placeholder="Enter your new password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            aria-invalid={passwordsMatchError ? "true" : "false"}
                            aria-describedby={passwordsMatchError ? "password-match-error" : undefined}
                        /> */}
                    </div>
                    <div>
                        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                            Confirm Password
                        </label>
                        <Input
                            type={showPassword ? "text" : "password"}
                            id="confirmPassword"
                            className={`block w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${passwordsMatchError ? 'border-red-500' : 'border-gray-300'}`}
                            placeholder="Confirm your new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            error={message}
                            trailingIcon={
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="text-gray-500 hover:text-gray-700 focus:outline-none pointer-events-auto"
                                    aria-label={showPassword ? "Hide Password" : "Show Password"}
                                >
                                    {showPassword ? (
                                        // Eye slashed (hidden)
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                            <path d="M1 1l22 22" />
                                        </svg>
                                    ) : (
                                        // Eye open (visible)
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    )}
                                </button>
                            }
                        />
                        {/* <input
                            type="password"
                            id="confirmPassword"
                            className={`block w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${passwordsMatchError ? 'border-red-500' : 'border-gray-300'}`}
                            placeholder="Confirm your new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            aria-invalid={passwordsMatchError ? "true" : "false"}
                            aria-describedby={passwordsMatchError ? "password-match-error" : undefined}
                        /> */}
                        {passwordsMatchError && (
                            <p id="password-match-error" className="mt-2 text-sm text-red-600">
                                Passwords do not match.
                            </p>
                        )}
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-gray-600 text-white py-3 px-4 rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 ease-in-out"
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="flex items-center justify-center">
                                <svg className="animate-spin h-5 w-5 text-white mr-3" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Setting Password...
                            </div>
                        ) : (
                            'Set Password'
                        )}
                    </button>
                </form>

                {/* This section is commented out using JSX comment syntax */}
                {/* <p className="mt-6 text-center text-sm text-gray-500">
                    Confirmation for user with salt: <span className="font-mono text-gray-700 break-all">{salt}</span>
                </p> */}
            </div>
        </div>
    );
};

export default ConfirmUser;
